// Shared metadata for the Data Sources feature.
export const SOURCE_TYPES = [
  { value: 'election_dates', label: 'Election Dates', icon: 'bi-calendar-event' },
  { value: 'supervisor_of_elections', label: 'Supervisor of Elections', icon: 'bi-person-badge' },
  { value: 'party_organization', label: 'Party Organization', icon: 'bi-flag' },
  { value: 'local_group', label: 'Local Group', icon: 'bi-people-fill' },
  { value: 'state_election_data', label: 'State Election Data', icon: 'bi-bank' },
  { value: 'other', label: 'Other', icon: 'bi-three-dots' },
];

export const PARSING_METHODS = [
  { value: 'ai_scrape', label: 'AI Scrape (single page)' },
  { value: 'ai_crawl', label: 'AI Crawl (multi-page directory)' },
  { value: 'manual', label: 'Manual' },
  { value: 'csv', label: 'CSV' },
  { value: 'api', label: 'API' },
  { value: 'html_table', label: 'HTML Table' },
];

export const DS_STATUSES = [
  { value: 'active', label: 'Active', badge: 'status-published' },
  { value: 'paused', label: 'Paused', badge: 'status-draft' },
  { value: 'failed', label: 'Failed', badge: 'status-in_review' },
];

export function sourceTypeLabel(v) {
  return SOURCE_TYPES.find((s) => s.value === v)?.label || v;
}
export function parsingMethodLabel(v) {
  return PARSING_METHODS.find((s) => s.value === v)?.label || v;
}
export function dsStatusMeta(v) {
  return DS_STATUSES.find((s) => s.value === v) || { value: v, label: v, badge: 'status-archived' };
}
